
import kirbyimage from "../kirbyimage.vue"

export default
{
    components: { kirbyimage },
    name: "sidebysidectaDefault",
    props:{
        content: Object
    },
    data()
    {
        return{
            isDark: this.content.dark === 'true' ? 'dark' : ''
        }
    }
}
